module.exports = __webpack_public_path__ + "img/AL271.dce6e15e.jpg";